/**
 * The typed-signature rule, as the server applies it (backend
 * src/signatures/signerName.mjs - keep the two in step): the typed name must
 * contain the profile's first and last names. A middle name is fine; initials
 * or someone else's name are not. Case and accents are ignored.
 *
 * Checked here only to say so before the signer presses Apply; the server is
 * the authority.
 */

const fold = (s) => String(s || '')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .toLowerCase();

const words = (s) => fold(s).split(/[^\p{L}\p{N}']+/u).filter(Boolean);

export const MAX_TYPED_NAME_LENGTH = 120;

export const profileName = (user) =>
  `${user?.firstName || ''} ${user?.lastName || ''}`.trim();

export const typedNameMatchesProfile = (typed, user) => {
  const required = [...words(user?.firstName), ...words(user?.lastName)];
  if (required.length === 0) return false;
  const have = new Set(words(typed));
  return required.every(w => have.has(w));
};

const signerName = { typedNameMatchesProfile, profileName, MAX_TYPED_NAME_LENGTH };
export default signerName;
